import React, { Component } from "react";
import "../../css/FilterButtonModal.css";
import FilterBarModal from "./FilterBarModal";
import FitlerOption from "./FitlerOption";
import { connect } from "react-redux";
import { chosenFilter } from "../../models";

class FilterButtonModal extends Component {
  state = {
    show: false
  };
  show = () => {
    this.setState({
      show: true
    });
  };
  close = () => {
    this.setState({
      show: false
    });
  };
  chosenFilterQuantity = () => {
    const { data } = this.props;
    // 計算選取多少個篩選條件
    let array = [];
    data.criteria.map(item =>
      this.props.chosenFilterList.find(data => {
        if (data.code === item.code) {
          return array.push(data);
        } else {
          return null;
        }
      })
    );
    return array.length > 0 ? (
      <span className="text-gold">({array.length})</span>
    ) : null;
  };
  render() {
    const { data, keywords } = this.props;
    return (
      <div>
        <div className="filter-button-option" onClick={this.show}>
          {data.categoryName}
          {this.chosenFilterQuantity()}
        </div>
        <FilterBarModal
          active={this.state.show}
          closeModal={this.close.bind(this)}
          closeParentModal={this.props.closeParentModal}
          title={data.categoryName}
          hidenFooter={false}
          keywords={keywords}
          content={data.criteria.map((item, index) => (
            <FitlerOption data={item} key={index} keywords={keywords} />
          ))}
        />
      </div>
    );
  }
}

FilterButtonModal.defaultProps = {
  keywords: ""
};

const mapStateToProps = state => {
  return {
    chosenFilterList: state.chosenFilter.chosenFilterList
  };
};

const mapDispatchToProps = () => {
  return {
    addFilter: data => chosenFilter.actions.addFilter(data),
    removeFilter: data => chosenFilter.actions.removeFilter(data)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterButtonModal);
